import { httpV2, http } from "@/api/index";

const Qs = require("qs");

/**
 * Solicita os registros de sinais detalhados para um ativo.
 * @param {number} id Id do ativo monitorado.
 * @returns Array com os registros de sinais disponíveis.
 */
const GetLatest = function(id)
{
	return httpV2.get(`/SignalRegisters/LastRegisters?monitoringElementId=${id}`);
};

/**
 * Realiza download de um registro.
 * @param {number} signalRegisterId Id do registro.
 * @param workName {string} Nome da Planta
 * @param testName {string} Nome da unidade geradora.
 * @returns Arquivo rfx contendo o registro.
 */
const DownloadRfx = function(signalRegisterId, workName, testName)
{
	const config = { responseType: "arraybuffer" };
	return http.get(`/DownloadRFX/${signalRegisterId}?workName=${workName}&testName=${testName}`, config);
};

/**
 * Solicita os registros de sinais detalhados para um ativo.
 * @param {object} params Parâmetros da requisição (data e id).
 * @returns Array com os registros de sinais disponíveis.
 */
const GetByDate = function(params)
{
	return httpV2.get("/SignalRegisters",
		{
			params:           params,
			paramsSerializer: params => Qs.stringify(params, { encode: false }),
		});
};

export default {
	GetLatest, GetByDate, DownloadRfx
};